import { Component, OnInit, ViewChild, ElementRef, HostListener, Renderer2 } from '@angular/core';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CalendarOptions, DateSelectArg, EventClickArg, EventApi } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';

import { Draggable } from '@fullcalendar/interaction'; // for dateClick
import {HssResponse} from "../../../../services/rest-api/HssResponse";
import {HssErrorResponse} from "../../../../services/rest-api/HssErrorResponse";
import {NotifyxService} from "../../../../services/notify/notifyx.service";
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {LhmsApiService} from "../../../../services/rest-api/lhms.api.service";
import { EventInput } from '@fullcalendar/angular';
import {CssDimValue, Identity} from "@fullcalendar/common";

// Add the following imports
let eventGuid = 0;
const TODAY_STR = () => {
  let dateObj = new Date();
  if (dateObj.getUTCMonth() < 10) {
    return dateObj.getUTCFullYear() + '-' + ('0' + (dateObj.getUTCMonth() + 1));
  } else {
    return dateObj.getUTCFullYear() + '-' + (dateObj.getUTCMonth() + 1);
  }
}

export function createEventId() {
  return String(eventGuid++);
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {

  searchForm: FormGroup | any;

  @ViewChild('externalEvents', {static: true}) externalEvents: ElementRef | undefined;

  holidayEvents: any;
  discoveredEvents: any;

  //INITIAL_EVENTS: EventInput[] = [...this.exampleEvents, ...this.birthdayEvents];
  EVENTS : EventInput[] = [];

  calendarOptions: CalendarOptions = {
    headerToolbar: {
      left: 'prev,today,next',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
    },
    initialView: 'timeGridWeek',
    weekends: true,
    editable: false,
    selectable: false,
    selectMirror: false,
    dayMaxEvents: true,
    slotMinTime: '06:00:00'
  };

  dataSource=[];
  tableStyle='bootstrap';
  loadingIndicator = true;
  itemsPerPage: any;
  isLoading: boolean | undefined;
  hallList: any;
  bookingDet: any[] | undefined;

  temp = [];
  rows = [];

  currentEvents: EventApi[] = [];
  currentDate: Date = new Date();

  plh_from_date: any;
  plh_to_date: any;

  //for loaders
  eventLoader: boolean = false;
  newsRepat: any[] = [1,2,3];

  constructor(public notify: NotifyxService,
              public translate: TranslateService,
              private _formBuilder: FormBuilder,
              private modalService: NgbModal,
              private renderer: Renderer2,
              public _lhmsApi: LhmsApiService) { }

  ngOnInit(): void {
    this.searchForm = this.createSearchForm();
    this.applyMobileStyles(window.innerWidth);
    this.getBookings();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.getBookings();
    this.applyMobileStyles(window.innerWidth);
  }

  private applyMobileStyles(viewportWidth: number) {
    const isMobile = viewportWidth < 768; // Adjust the threshold as needed

    if (isMobile) {
      // Mobile
      console.log('MOBILE');
      this.calendarOptions = {
        initialView: 'listWeek',
        selectable: true,
        weekends: true,
        editable: false,
        selectMirror: false,
        dayMaxEvents: true,
        slotMinTime: '06:00:00',
        headerToolbar: false,
        viewHeight: 'auto',
        height : 'auto',
        contentHeight: 'auto'

      };

    } else {
      // Desktop
      this.calendarOptions = {
        headerToolbar: {
          left: 'prev,today,next',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        initialView: 'timeGridWeek',
        weekends: true,
        editable: false,
        selectable: false,
        selectMirror: false,
        dayMaxEvents: true,
        slotMinTime: '06:00:00'
      };
    }
  }
  createSearchForm(): FormGroup {
    return this.searchForm = this._formBuilder.group({
        from_date: [''],
        to_date: [''],
      }
    );
  }

  // Get bookings for given calender date
  getBookings() {
    this.isLoading = true;

    const firstDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
    const lastDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);

    this.plh_from_date = this.formatDatePlaceholder(firstDate);
    this.plh_to_date = this.formatDatePlaceholder(lastDate);

    let from_date = this.formatDate(firstDate);
    let to_date = this.formatDate(lastDate);


    // @ts-ignore
    const data = this.searchForm.getRawValue();

    if(data.from_date !== ""){
      // @ts-ignore
      from_date = this.toModel(data.from_date);
      // @ts-ignore
      to_date = this.toModel(data.to_date);
    }

    this.isLoading = true;
    this._lhmsApi.getBookingSummery(from_date, to_date).subscribe(
      (response: HssResponse<any>) => {
        this.bookingDet = response.body;
        console.log('this.bookingDet',this.bookingDet);

        // @ts-ignore
        let holidayEvents = [];
        // @ts-ignore
        let previousBookingId;

        let backgroundColor = 'rgba(241,0,117,.25)';
        let borderColor = '#f10075';

        // @ts-ignore
        this.bookingDet.forEach(time => {

          // Add condition to check if booking_id is different
          // @ts-ignore
          if (time.booking_id !== previousBookingId) {
            backgroundColor = this.getRandomColor();
            borderColor = this.getRandomColor();
          }

          holidayEvents.push({
            id: createEventId(),
            start: time.bookstart,
            end: time.bookend,
            title: time?.lecture_hall?.hall_name + ', ' + time?.hall_booking?.purpose,
            backgroundColor: backgroundColor,
            borderColor: borderColor
          });

          previousBookingId = time.booking_id; // Remember the current booking_id for the next iteration
        });

        this.isLoading = false;

        // @ts-ignore
        this.calendarOptions.events = [...holidayEvents]; // Update calendarOptions.events
        this.isLoading = false;
        this.notify.presentToast(this.translate.instant(response.message), 'success');
      },
      (error: HssErrorResponse<any>) => {
        this.isLoading = false;
        const message = Array.isArray(error.message) ? error.message.join('<br/>') : error.message;
        this.notify.presentToast(this.translate.instant(message), 'error');
      }
    );
  }

  getRandomColor(): string {
    const letters = '0123456789ABCDEF';
    let color = '#';
    // Generate light colors by choosing values for red, green, and blue channels closer to their maximum (FF)
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 10) + 6]; // Start from 6 to choose lighter colors
    }
    return color;
  }


  formatDatePlaceholder(date: Date): string {
    return `${date.getFullYear()}-${this.padZero(date.getMonth() + 1)}-${this.padZero(date.getDate())}`;
  }

  formatDate(date: Date): string {
    return `${date.getFullYear()}-${this.padZero(date.getMonth() + 1)}-${this.padZero(date.getDate())} 00:00:00`;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  toModel(date: { year: number; month: number; day: number | undefined; }) {
    if (!date) return null;
    const formattedDate = new Date(date.year, date.month - 1, date.day, 0, 0, 0);
    const year = formattedDate.getFullYear();
    const month = String(formattedDate.getMonth() + 1).padStart(2, '0');
    const day = String(formattedDate.getDate()).padStart(2, '0');
    const hours = '00';
    const minutes = '00';
    const seconds = '00'; // Since you're not taking seconds parameter
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  handleDateSelect(selectInfo: DateSelectArg) {
    const title = prompt('Please enter a new title for your event');
    const calendarApi = selectInfo.view.calendar;

    calendarApi.unselect(); // clear date selection

    if (title) {
      calendarApi.addEvent({
        id: createEventId(),
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      });
    }
  }

  handleEventClick(clickInfo: EventClickArg) {
    if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
      clickInfo.event.remove();
    }
  }

  handleEvents(events: EventApi[]) {
    this.currentEvents = events;
  }

}
